import { useQuery } from "@tanstack/react-query";
import {
  getEntitlementsApi,
  getMeteredUsageApi,
} from "../api/entitlementsApi";
import type { StoreId } from "@KassaroAB/shared/types/ids";

export const useGetEntitlementsQuery = (
  storeId: StoreId | null,
  date?: string
) => {
  return useQuery({
    queryKey: ["stores", storeId, "entitlements", date ?? "today"],
    queryFn: () => getEntitlementsApi(storeId!, date),
    enabled: !!storeId,
  });
};

export const useGetMeteredUsageQuery = (
  storeId: StoreId | null,
  yearMonth?: string
) => {
  return useQuery({
    queryKey: ["stores", storeId, "meteredUsage", yearMonth ?? "current"],
    queryFn: () => getMeteredUsageApi(storeId!, yearMonth),
    enabled: !!storeId,
  });
};
